import { render, h, Component } from 'preact';
import pendingPromise from 'utils/pendingPromise';
import { joinClasses } from 'utils/utils';

import s from 'utils/modal.scss';

export const MODAL_TYPES = {
	OK_CANCEL: 'okCancel',
	YES_NO: 'yesNo',
};

export class BaseModal extends Component {
	constructor(props) {
		super(props);
		this.onSubmit = this.onSubmit.bind(this);
	}
	onSubmit(e) {
	}
	get dialog() {
		return this.base.closest('dialog');
	}
	renderTitle() {
		return this.props.title;
	}
	renderContent() {
		return this.props.message || this.props.children;
	}
	renderButtons() {
		return [
			<button class={joinClasses(s.button, s.primary)} type="submit" value="ok">OK</button>,
		];
	}
	render() {
		return (
			<form method="dialog" onSubmit={this.onSubmit}>
				<div class={s.title}>{this.renderTitle()}</div>
				<div class={s.content}>{this.renderContent()}</div>
				<div class={s.buttons}>{this.renderButtons()}</div>
				{/* This button has to be last to not be the main submit button when typing enter in a text field */}
				<button class={s.close} type="submit" value="cancel" formnovalidate />
			</form>
		);
	}
}

class AlertModal extends BaseModal {
}
class ConfirmModal extends BaseModal {
	renderButtons() {
		if (this.props.type === MODAL_TYPES.YES_NO) {
			const primaryButton = this.props.primaryButton || 'yes';
			return [
				<button class={joinClasses(s.button, primaryButton === 'yes' && s.primary)} type="submit" value="yes">Yes</button>,
				<button class={joinClasses(s.button, primaryButton === 'no' && s.primary)} type="submit" value="no">No</button>,
			];
		}
		const primaryButton = this.props.primaryButton || 'ok';
		return [
			<button class={joinClasses(s.button, primaryButton === 'ok' && s.primary)} type="submit" value="ok">OK</button>,
			<button class={joinClasses(s.button, primaryButton === 'cancel' && s.primary)} type="submit" value="cancel">Cancel</button>,
		];
	}
}

export async function alert(message, options) {
	return show(<AlertModal message={message} title={options?.title} />, options);
}
export async function confirm(message, options) {
	let result = await show(<ConfirmModal message={message} title={options?.title} type={options?.type} primaryButton={options?.primaryButton} onSubmit={options.onSubmit} />, options);
	if (result == null || result === 'cancel') {
		return null;
	}
	return result === 'ok' || result === 'yes';
}

export async function show(content, options) {
	let promise = pendingPromise();
	let dialog = document.createElement('dialog');
	dialog.className = joinClasses(s.dialog, options?.class);
	render(content, dialog);
	dialog.addEventListener('cancel', () => promise.resolve(null));
	dialog.addEventListener('close', () => promise.resolve(dialog.returnValue === 'cancel' ? null : dialog.returnValue));
	document.body.append(dialog);
	dialog.showModal();

	let result = await promise;

	document.body.removeChild(dialog);
	return result;
}